
import { defineComponent } from "vue";

export default defineComponent({
  name: "StatusIndicator",
  props: ["status"],
});
